<template>
  <v-text-field
    v-bind="$attrs"
    type="number"
    @input="$emit('input', ($event || $event === 0) ? +$event : null)"
    @change="$emit('change', ($event || $event === 0) ? +$event : null)"
  />
</template>

<script>
export default {
  name: 'AgNumberField',
}
</script>
